import { render, staticRenderFns } from "./_template-breadcrumb.vue?vue&type=template&id=25a3b95e&scoped=true&"
import script from "./_template-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./_template-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./_template-breadcrumb.vue?vue&type=style&index=0&id=25a3b95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3b95e",
  null
  
)

export default component.exports